import { Ref } from 'react';
import { ElementProps } from '../element';
import { Row } from '../flex/Row';
import { Lottie } from '../lottie';
import starEffect from './effect_stars.json';
import * as styles from './starEffect.css';

interface StarEffectProps {
  loop?: boolean;
  width?: ElementProps['width'];
  ref?: Ref<HTMLDivElement>;
}

export const StarEffect = ({
  width = '100%',
  loop = false,
  ref,
}: StarEffectProps) => {
  return (
    <Row width={width} alignItems="center" justifyContent="center" ref={ref}>
      <div className={styles.lottieWrapper}>
        <Lottie
          name="startEffect"
          animationData={starEffect}
          autoplay
          loop={loop}
        />
      </div>
    </Row>
  );
};
